import {ReactComponent as DeleteIcon} from './delete.svg'

function Delete() {
  return <DeleteIcon />
}

export default Delete
